import { MRT_Row, MRT_TableInstance } from "material-react-table";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { UserManagementRow } from "./typings/user-management.type";

type Props = {
  table: MRT_TableInstance<UserManagementRow>;
  row: MRT_Row<UserManagementRow>;
  setIsDeleteModalOpen: (o: boolean) => void;
  setDeletionSelected: (s: string[]) => void;
};
export const UserManagementTableRowActions = ({
  table,
  row,
  setIsDeleteModalOpen,
  setDeletionSelected
}: Props) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", gap: "1rem" }}>
      <Tooltip title={<Typography>{t("Edit")}</Typography>} aria-label={"Edit"}>
        <IconButton
          data-testid="user-management-row-edit-btn"
          onClick={() => table.setEditingRow(row)}
          size="large"
        >
          <Edit />
        </IconButton>
      </Tooltip>
      <Tooltip title={<Typography>{t("Delete")}</Typography>} aria-label={"Delete"}>
        <IconButton
          data-testid="user-management-row-delete-btn"
          onClick={() => {
            setIsDeleteModalOpen(true);
            setDeletionSelected([row.original.email]);
          }}
          size="large"
        >
          <Delete />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
